import React, { useEffect, useState } from 'react'

import Header from '../Core/Header'
import { patient } from '../../Assets/dummyPatient'
import { motion } from 'motion/react'
import { getAllDoctors } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'
import { baseURLImg } from '../../Services/api_endpoints'

const fileData=[
  {
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },
  {
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },
]

const Doctor = () => {
 const[list,setList]=useState(patient)
  const[verified,setVerified]=useState(false)
    const token = useSelector((state) =>JSON.parse( state.auth.token));
  let item1={
     name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]
  }
  const [modal,setModal]=useState(false)
  const[doctors,setDoctors]=useState([])

  const handleGetDoctors=async()=>{
    try {
        const res= await getAllDoctors(token)
        console.log("doctors",res);
        if(res.status===200){
            setDoctors(res.data.data)
        }
        
    } catch (error) {
        console.log(error);
        
    }
  }

  useEffect(() => {
    handleGetDoctors()
  }, [])
  
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
     <section
  style={{
    marginTop: "80px",
    height: "calc(100vh - 80px)",
    background: "linear-gradient(135deg, #eef2f7, #ffffff, #e5e7eb)",
    padding: "20px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    transition: "0.3s ease",
    filter: modal ? "blur(8px)" : "none",
    pointerEvents: modal ? "none" : "auto",
  }}
>
  {/* Header */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "15px",
      padding: "18px 20px",
      background: "linear-gradient(135deg, #172b4d, #29496e)",
      borderRadius: "14px",
      boxShadow: "0 5px 18px rgba(23, 43, 77, 0.15)",
      marginBottom: "20px",
    }}
  >
    <div>
      <p
        style={{
          color: "#ffffff",
          fontSize: "23px",
          fontWeight: "700",
          margin: 0,
        }}
      >
        All Doctors
      </p>

      <p
        style={{
          color: "#d5e2f1",
          fontSize: "13px",
          margin: "6px 0 0",
        }}
      >
        Manage doctor profiles and medical information
      </p>
    </div>

    <input
      placeholder="Search Patient"
      style={{
        width: "240px",
        maxWidth: "100%",
        boxSizing: "border-box",
        border: "1px solid #dce3ed",
        borderRadius: "9px",
        fontSize: "14px",
        padding: "11px 14px",
        outline: "none",
        backgroundColor: "#ffffff",
        color: "#1e293b",
      }}
    />
  </div>

  {/* Doctors List */}
  <div
    style={{
      flex:  1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: "2px 4px 15px 2px",
    }}
  >
    {doctors?.length > 0 ? (
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(min(100%, 285px), 1fr))",
          gap: "20px",
          alignItems: "stretch",
        }}
      >
        {doctors.map((item, index) => (
          <div
            key={item?.user?.id || item?.user?.medical_id || index}
            style={{
              minWidth: 0,
              position: "relative",
              borderRadius: "15px",
              padding: "14px",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 14px rgba(15, 23, 42, 0.07)",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              boxSizing: "border-box",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow =
                "0 10px 25px rgba(15, 23, 42, 0.13)";
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow =
                "0 4px 14px rgba(15, 23, 42, 0.07)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            {/* Track Data Button */}
            <button
              type="button"
              onClick={() => setModal(true)}
              style={{
                position: "absolute",
                top: "22px",
                right: "22px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "7px 10px",
                borderRadius: "9px",
                backgroundColor: "#fff7df",
                border: "1px solid #f4df9b",
                color: "#805b12",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "700",
                zIndex: 1,
              }}
            >
              <img
                src="/Assets/data.png"
                alt=""
                style={{
                  width: "18px",
                  height: "18px",
                  objectFit: "contain",
                }}
              />
              Track Data
            </button>

            {/* Doctor Profile Image */}
            <div
              style={{
                width: "100%",
                height: "190px",
                borderRadius: "11px",
                overflow: "hidden",
                backgroundColor: "#e9eef5",
              }}
            >
              <img
                src={
                  item?.user?.profile_image
                    ? `${baseURLImg}${item.user.profile_image}`
                    : "/Assets/diagonasitic.jpg"
                }
                alt={`${item?.user?.first_name || ""} ${
                  item?.user?.last_name || ""
                }`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>

            {/* Doctor Details */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                minWidth: 0,
              }}
            >
              {/* Name and Gender */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "700",
                    color: "#172b4d",
                    margin: 0,
                    overflowWrap: "anywhere",
                  }}
                >
                  {item?.user?.first_name} {item?.user?.last_name}
                </p>

                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    backgroundColor: "#f1f5f9",
                    borderRadius: "7px",
                    padding: "5px 7px",
                    flexShrink: 0,
                  }}
                >
                  {item?.user?.gender || "N/A"}
                </span>
              </div>

              {/* Email */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  minWidth: 0,
                }}
              >
                <span>✉️</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#475569",
                    overflowWrap: "anywhere",
                  }}
                >
                  {item?.user?.email || "Email not available"}
                </span>
              </div>

              {/* Phone */}
              <div style={{ display: "flex", gap: "8px" }}>
                <span>📞</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#475569",
                  }}
                >
                  {item?.user?.primary_number || "Phone not available"}
                </span>
              </div>

              {/* Date of Birth */}
              <div style={{ display: "flex", gap: "8px" }}>
                <span>🎂</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#475569",
                  }}
                >
                  DOB: {item?.user?.dob || "Not available"}
                </span>
              </div>

              {/* Medical ID */}
              <div
                style={{
                  padding: "10px",
                  backgroundColor: "#eff6ff",
                  borderRadius: "9px",
                }}
              >
                <p
                  style={{
                    fontSize: "11px",
                    color: "#64748b",
                    fontWeight: "600",
                    margin: "0 0 4px",
                  }}
                >
                  MEDICAL ID
                </p>
                <p
                  style={{
                    fontSize: "13px",
                    color: "#2563a6",
                    fontWeight: "700",
                    margin: 0,
                    overflowWrap: "anywhere",
                  }}
                >
                  {item?.user?.medical_id || "Not available"}
                </p>
              </div>

              {/* Aadhaar */}
              <div style={{ display: "flex", gap: "8px" }}>
                <span>🪪</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#64748b",
                    overflowWrap: "anywhere",
                  }}
                >
                  Aadhaar: {item?.user?.aadhaar_id || "Not available"}
                </span>
              </div>

              {/* License */}
              <div style={{ display: "flex", gap: "8px" }}>
                <span>▤</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#2563a6",
                    overflowWrap: "anywhere",
                  }}
                >
                  License No: {item?.license_number || "Not available"}
                </span>
              </div>

              {/* Address */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <span>📍</span>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#334155",
                    lineHeight: "1.5",
                    overflowWrap: "anywhere",
                  }}
                >
                  {item?.user?.address || "Address not available"}
                </span>
              </div>

              {/* Assigned Doctors */}
              <div
                style={{
                  borderTop: "1px solid #edf0f5",
                  paddingTop: "12px",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#334155",
                    margin: "0 0 9px",
                  }}
                >
                  Assigned Doctors
                </p>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                  }}
                >
                  {Array.isArray(item?.AssignedDoc) &&
                  item.AssignedDoc.length > 0 ? (
                    item.AssignedDoc.map((doc, i) => (
                      <span
                        key={i}
                        style={{
                          fontSize: "11px",
                          padding: "6px 9px",
                          borderRadius: "7px",
                          backgroundColor: "#e8f1ff",
                          color: "#2458a6",
                          fontWeight: "600",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {doc}
                      </span>
                    ))
                  ) : (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#94a3b8",
                        fontStyle: "italic",
                      }}
                    >
                      No doctors assigned
                    </span>
                  )}
                </div>
              </div>

              {/* Diseases */}
              <div
                style={{
                  borderTop: "1px solid #edf0f5",
                  paddingTop: "12px",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#334155",
                    margin: "0 0 9px",
                  }}
                >
                  Diseases
                </p>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                  }}
                >
                  {Array.isArray(item?.disease) && item.disease.length > 0 ? (
                    item.disease.map((disease, i) => (
                      <span
                        key={i}
                        style={{
                          fontSize: "11px",
                          padding: "6px 9px",
                          borderRadius: "7px",
                          backgroundColor: "#e5f6ed",
                          color: "#176b45",
                          fontWeight: "600",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {disease}
                      </span>
                    ))
                  ) : (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#94a3b8",
                        fontStyle: "italic",
                      }}
                    >
                      No diseases listed
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div
        style={{
          minHeight: "250px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#64748b",
          gap: "10px",
        }}
      >
        <div style={{ fontSize: "42px" }}>🩺</div>

        <p
          style={{
            fontSize: "19px",
            fontWeight: "700",
            color: "#334155",
            margin: 0,
          }}
        >
          No Doctors Found
        </p>

        <p style={{ fontSize: "14px", margin: 0 }}>
          Registered doctors will appear here.
        </p>
      </div>
    )}
  </div>
</section>
      {
        modal && 
        <motion.div 
        initial={{y:150,opacity:1}}
        animate={{y:0,opacity:1}}
        transition={{
          duration:1.3
        }}
        style={{
          height:"90vh",width:"100%",backgroundColor:"white",
          position:"absolute",zIndex:999,top:"200px",padding:"20px",borderRadius:"10px"
        }}
        >
          <div style={{width:"100%",height:"60px",display:"flex",alignItems:"center",justifyContent:"left",gap:"30px",padding:'20px',borderBottom:'1px solid gray',fontSize:'18px',fontWeight:700,cursor:"pointer"}}>
          <p onClick={()=>setModal(false)}>X</p>
          {
          !verified?
          <div style={{display:"flex",alignItems:"center",justifyContent:"left",gap:"20px",padding:"2px 20px",backgroundColor:"#fccfb0ff",borderRadius:"6px"}}>
            <p>Otp sent to patient's email</p>
            <input style={{border:"1px solid gray",borderRadius:"5px",outline:"none",fontSize:"12px",padding:"6px"}}
            placeholder='Enter OTP'/>
            <p onClick={()=>setVerified(true)}
            style={{cursor:"pointer",padding:"7px",borderRadius:"5px",backgroundColor:"#5b8fffff",fontSize:"12px",fontWeight:"700",color:"white"}}>verify</p>
          </div>
          :
          <p >Tracking data of patient</p>
          }
          
          </div>
          
          <div style={{height:"calc(90vh-60px)",width:"100%",backgroundColor:"#eeeeeeff",minHeight:"calc(90vh-60px)",maxHeight:"calc(90vh-60px)",
            display:"flex",alignItems:"start",justifyContent:"left", transition: "0.3s ease",filter: !verified ? "blur(8px)" : "none", pointerEvents: !verified ? "none" : "auto",
          }}>
             <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <img src='/Assets/patient.webp' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item1.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Age:{item1.Age}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>Reg:{item1.registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item1.Address}</span>
                            </p>
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Doctors</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item1.AssignedDoc.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                      <p style={{fontSize:"14px",fontWeight:"800"}}>Diseases:</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item1.disease.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    

                    </div>
            <div style={{width:"70%"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"left",gap:"30px",padding:"20px"}}>
                <label style={{fontSize:"15px",fontWeight:"700"}}>Upload new Prescription</label>
                <input type='file'style={{backgroundColor:"#afaeaeff",borderRadius:"6px",padding:"4px"}}/>

              </div>
              <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",maxHeight:"50vh",height:"50vh",overflowY:"auto"}}>
                        {
                          fileData.map((file)=>(
                            <div style={{padding:"10px",borderRadius:"10px",backgroundColor:"#bbe3fdff",margin:"6px"}}>
                              <img src='/Assets/doc-data.png' style={{width:"180px",height:"220px"}}/>
                              <p style={{fontSize:"13px",fontWeight:"700"}}>Doctor :{file.doc}</p>
                              <p style={{fontSize:"12px",fontWeight:"700"}}>Date:{file.date}</p>
                              </div>
                          ))
                        }

              </div>

            </div>

          </div>

          </motion.div>
      }


    </div>
  )
}

export default Doctor
